const LIST_RETURN_HASH_KEY = 'purchaseRequisition.listReturnHash';
const MOBILE_LIST_RETURN_HASH_KEY = 'purchaseRequisitionMobile.listReturnHash';

export function queryTokenForStatus(requisitionStatus) {
    switch (requisitionStatus) {
        case 'PURCHASE_ORDER':
            return 'PurchaseOrder';
        case 'DELIVERY_NOTE':
            return 'DeliveryNote';
        case 'RETURN':
            return 'Return';
        case 'OPEN':
        default:
            return 'PurchaseRequisition';
    }
}

export function buildListReturnHash(requisitionStatus, statusLocked) {
    if (!statusLocked) {
        return '#/purchaseRequisition';
    }
    return '#/purchaseRequisition?' + queryTokenForStatus(requisitionStatus);
}

export function rememberListReturnHash(requisitionStatus, statusLocked) {
    try {
        sessionStorage.setItem(LIST_RETURN_HASH_KEY, buildListReturnHash(requisitionStatus, statusLocked));
    } catch (e) {
        // ignore
    }
}

export function getPurchaseRequisitionListReturnHash() {
    try {
        const stored = sessionStorage.getItem(LIST_RETURN_HASH_KEY);
        if (stored && stored.indexOf('purchaseRequisition') >= 0 && stored.indexOf('Save') < 0) {
            return stored;
        }
    } catch (e) {
        // ignore
    }
    return '#/purchaseRequisition';
}

export function buildMobileListReturnHash(requisitionStatus, statusLocked) {
    if (!statusLocked) {
        return '#/purchaseRequisitionMobile';
    }
    return '#/purchaseRequisitionMobile?' + queryTokenForStatus(requisitionStatus);
}

export function rememberMobileListReturnHash(requisitionStatus, statusLocked) {
    try {
        sessionStorage.setItem(MOBILE_LIST_RETURN_HASH_KEY, buildMobileListReturnHash(requisitionStatus, statusLocked));
    } catch (e) {
        // ignore
    }
}

export function getPurchaseRequisitionMobileListReturnHash() {
    try {
        const stored = sessionStorage.getItem(MOBILE_LIST_RETURN_HASH_KEY);
        if (stored && stored.indexOf('purchaseRequisitionMobile') >= 0 && stored.indexOf('Save') < 0) {
            return stored;
        }
    } catch (e) {
        // ignore
    }
    return '#/purchaseRequisitionMobile';
}
